import React from "react";
import Toggle from "./Toggle";

const LoadingScreen = ({ title }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex flex-col xl:flex-row items-start justify-between">
        <h1 className="text-navy-blue text-2xl font-bold">{title}</h1>

        <div className="flex sm:flex-row flex-col justify-center items-center">
          <Toggle />
        </div>
      </div>
      <div className="bg-white min-h-screen mt-4">
        <div className="flex flex-col items-center justify-center mt-[88px]">
          <h1 className="w-[348px] text-[18.75px] text-ash text-center font-normal">
            System is loading your required information
          </h1>
          <span className="mt-8">
            <svg
              className="animate-spin"
              width="151"
              height="150"
              viewBox="0 0 151 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M74.1392 6.41631C71.9712 7.11943 70.6528 8.26201 69.8911 10.0198C69.2173 11.6604 69.2173 44.5901 69.8911 46.2308C71.7661 50.6839 77.8892 51.2698 80.731 47.2269L81.6099 45.9378L81.6978 28.7698C81.7563 17.0804 81.6978 11.221 81.4634 10.4886C80.6431 7.64677 76.8345 5.5374 74.1392 6.41631Z"
                fill="#333333"
              />
              <path
                d="M28.8753 25.1667C25.7113 26.6316 24.3929 30.2058 25.8285 33.3991C26.2679 34.3659 28.846 37.1491 35.555 43.8874C40.5941 48.9265 45.2816 53.4089 46.014 53.8484C47.889 54.9616 50.2913 54.9616 52.2249 53.8191C55.1546 52.1198 56.1507 48.2819 54.4515 45.4109C54.012 44.6784 49.5296 39.9909 44.4906 34.9519C34.7347 25.2546 33.973 24.6101 31.3656 24.6101C30.6331 24.6101 29.5199 24.8737 28.8753 25.1667Z"
                fill="#333333"
              />
              <path
                d="M117.205 25.2253C116.238 25.6648 113.455 28.2429 106.717 34.9519C101.678 39.9909 97.1953 44.6784 96.7558 45.4109C95.0566 48.2819 96.0527 52.1198 98.9824 53.8191C100.916 54.9616 103.318 54.9616 105.193 53.8484C105.926 53.4089 110.613 48.9265 115.652 43.8874C122.361 37.1491 124.939 34.3659 125.379 33.3991C127.752 28.1257 122.478 22.8523 117.205 25.2253Z"
                fill="#333333"
              />
              <path
                d="M10.5646 69.3168C5.49628 71.514 5.84784 79.3363 11.092 80.8597C11.8244 81.0941 17.6838 81.1527 29.3732 81.0941L46.5412 81.0062L47.8303 80.1273C51.8732 77.2855 51.2873 71.1625 46.8342 69.2875C45.2228 68.6429 12.1174 68.6429 10.5646 69.3168Z"
                fill="#333333"
              />
              <path
                d="M104.315 69.3168C99.2463 71.514 99.5978 79.3363 104.842 80.8597C105.574 81.0941 111.434 81.1527 123.123 81.0941L140.291 81.0062L141.58 80.1273C145.623 77.2855 145.037 71.1625 140.584 69.2875C138.973 68.6429 105.867 68.6429 104.315 69.3168Z"
                fill="#333333"
              />
              <path
                d="M47.1562 95.5958C45.4277 96.2403 44.8417 96.797 35.4081 106.26C28.8163 112.881 26.2675 115.635 25.828 116.602C23.455 121.875 28.7284 127.149 34.0019 124.775C34.9687 124.336 37.7519 121.758 44.4902 115.049C49.5292 110.01 54.0116 105.322 54.4511 104.59C56.121 101.777 55.1542 97.8809 52.3417 96.2403C50.789 95.3321 48.5917 95.0684 47.1562 95.5958Z"
                fill="#333333"
              />
              <path
                d="M100.447 95.4786C96.5216 96.7384 94.7345 101.191 96.756 104.59C97.1955 105.322 101.678 110.01 106.717 115.049C113.455 121.758 116.238 124.336 117.205 124.775C122.479 127.149 127.752 121.875 125.379 116.602C124.94 115.635 122.361 112.852 115.652 106.113C110.613 101.074 105.955 96.5919 105.311 96.211C103.963 95.42 101.707 95.0977 100.447 95.4786Z"
                fill="#333333"
              />
              <path
                d="M74.1392 100.166C71.9712 100.869 70.6528 102.012 69.8911 103.77C69.2173 105.41 69.2173 138.34 69.8911 139.981C71.7661 144.434 77.8892 145.02 80.731 140.977L81.6099 139.688L81.6978 122.52C81.7563 110.83 81.6978 104.971 81.4634 104.239C80.6431 101.397 76.8345 99.2874 74.1392 100.166Z"
                fill="#333333"
              />
            </svg>
          </span>
          <p className="text-center text-[18.75px] text-dark-ash font-bold mt-6">
            Loading...
          </p>
        </div>
      </div>
      <style>
        {`
        @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

        `}
      </style>
    </div>
  );
};

export default LoadingScreen;
